import {
  Certificate,
  ClockCounterClockwise,
  IdentificationCard,
  PaperPlaneTilt,
} from "@phosphor-icons/react";

const tags = [
  {
    icon: ClockCounterClockwise,
    title: "Lifetime Access",
    narasi: "Akses kursus seumur hidup",
  },
  {
    icon: IdentificationCard,
    title: "Mentor Bersertifikasi",
    narasi: "Ilmu dari mentor berpengalaman",
  },
  {
    icon: PaperPlaneTilt,
    title: "Gratis untuk Pemula",
    narasi: "Akses gratis untuk pemula",
  },
  {
    icon: Certificate,
    title: "E-Sertifikat",
    narasi: "Download gratis E-Sertifikat",
  },
];

export default tags;
